import { Component, Inject, OnDestroy, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { NotificationService } from '../../services/notifications.service';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { Subject, takeUntil } from 'rxjs';
import { BaseService } from '../../services/base.service';
import moment from 'moment';
import { OlxAdvertService } from '../../services/olx-advert.service';
import { SelectType } from '../../components/select/select.interface';

interface FormDateTime {
  from: FormControl;
  to: FormControl;
  days: FormControl;
  is_all_day: FormControl;
}

@Component({
  selector: 'app-advert-plain',
  templateUrl: './planner-automation.component.html',
  styleUrls: ['./planner-automation.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class PlannerAutomationComponent implements OnInit, OnDestroy {
  private readonly destroy$ = new Subject<null>();

  public isLoader: boolean = false;
  public selected = null;
  public today = new Date();
  public day: any[] = [];
  public is_all_day: boolean = false;
  public all_day: boolean = false;

  formPlanner!: FormGroup<FormDateTime>;

  days = [
    { name: 'monday', value: 'MONDAY', isTranslate: true },
    { name: 'tuesday', value: 'TUESDAY', isTranslate: true },
    { name: 'wednesday', value: 'WEDNESDAY' },
    { name: 'thursday', value: 'THURSDAY' },
    { name: 'friday', value: 'FRIDAY' },
    { name: 'saturday', value: 'SATURDAY' },
    { name: 'sunday', value: 'SUNDAY' },
  ];

  constructor(
    private notificationService: NotificationService,
    private dialogRef: MatDialogRef<PlannerAutomationComponent>,
    public readonly baseService: BaseService,
    private readonly olxAdvertService: OlxAdvertService,
    @Inject(MAT_DIALOG_DATA) public data: any,
  ) {
    this.day = data?.data?.days;
    this.is_all_day = data?.data?.is_all_day;
  }

  ngOnInit(): void {
    this.onInitForm();
  }

  ngOnDestroy(): void {
    this.destroy$.next(null);
    this.destroy$.complete();
  }

  onInitForm(): void {
    this.formPlanner = new FormGroup<FormDateTime>({
      days: new FormControl(this.day ? this.expandDays(this.day) : []),
      from: new FormControl(moment().format('HH:mm') ?? '', [Validators.required, Validators.minLength(5)]),
      to: new FormControl(moment().format('HH:mm') ?? '', [Validators.required, Validators.minLength(5)]),
      is_all_day: new FormControl(this.is_all_day || false),
    });

    if (this.formPlanner.controls.is_all_day.value) {
      this.formPlanner.controls.from.disable();
      this.formPlanner.controls.to.disable();
    } else {
      this.formPlanner.controls.from.enable();
      this.formPlanner.controls.to.enable();
    }
  }

  onSave() {
    this.dialogRef.close(this.formPlanner.getRawValue());
  }

  expandDays(days: string[]): any[] {
    const abbreviations: Record<string, string> = {
      tue: 'TUESDAY',
      thu: 'THURSDAY',
      sat: 'SATURDAY',
      wed: 'WEDNESDAY',
      fri: 'FRIDAY',
      mon: 'MONDAY',
      sun: 'SUNDAY',
    };
    const result = days.map((day) => {
      const dayLower = day.toLowerCase();
      return abbreviations[dayLower] || dayLower.toUpperCase();
    });
    return result;
  }

  clickIsDay() {
    if (this.formPlanner.controls.is_all_day.value) {
      this.formPlanner.controls.from.disable();
      this.formPlanner.controls.to.disable();
    } else {
      this.formPlanner.controls.from.enable();
      this.formPlanner.controls.to.enable();
    }
  }

  protected readonly SelectType = SelectType;
}
